import { render } from "./AnnSetCopyModal.vue?vue&type=template&id=0d463a7a&scoped=true"
import script from "./AnnSetCopyModal.vue?vue&type=script&lang=js"
export * from "./AnnSetCopyModal.vue?vue&type=script&lang=js"

import "./AnnSetCopyModal.vue?vue&type=style&index=0&id=0d463a7a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d463a7a"]])

export default __exports__